import { useContext, useState } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer } from "src/style"
import { FiChevronDown } from "react-icons/fi"
import { TxPinVerificationD2, InvestmentConfirmationD2, AppCenterPopupD2, CenterPopupHeaderD2 } from "src/component"
import utility from "src/utils/utility"

export const NewSavingsD2: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({
        goal: '', amount: '', sourceAccount: '', 
        startDate: '', tenure: '', investmentResult: true
    })
    const [view, setView] = useState('new-investment')

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        if (e.target.name === 'amount') {
            let val = e.target.value.replace(/,/g, '')
            if (!isNaN(Number(val))) {
                setInput({...input, [e.target.name]: val, investmentResult: false})
            }
        }
        else setInput({...input, [e.target.name]: e.target.value, investmentResult: false})
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        if (!input.investmentResult) return setInput({...input, investmentResult: true})
        setView('investment-confirmation')
    }

    async function handleSubmit() {
        notifier.show('Savings Confirmed', null, 'success')
        close()
    }

    return (
        <>
            { view === 'new-investment' &&
                <AppCenterPopupD2 height={input.investmentResult ? '73' : '63'} zIndex='6' overflow='hidden' close={close}>
                    <CenterPopupHeaderD2 title='Add New Savings' close={close} />
                    <CustomContainer 
                        height={input.investmentResult ? '73' : '63'}
                        style={{maxHeight: '86%'}}
                        className="popup-content-container"
                    >
                        <Form onSubmit={handleProceed}>
                        <   FormGroup>
                                <label>Goal</label>
                                <input 
                                    placeholder='Enter Goal' 
                                    name='goal'
                                    value={input.goal}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>Target Amount</label>
                                <input 
                                    placeholder='Enter Target Amount' 
                                    name='amount'
                                    value={input.amount ? utility.moneyFormat(input.amount) : ''}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroupWithIcon>
                                <label>Tenure/Investment Period</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='tenure'
                                        value={input.tenure}
                                        style={{color: input.tenure ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        //required
                                    >
                                        <option value="">Select Tenure</option>
                                        <option value="360 Days">360 Days</option>
                                        <option value="1 month">1 month</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroup>
                                <label>Start Date</label>
                                <input 
                                    placeholder='dd/mm/yyyy' 
                                    type='date'
                                    name='startDate'
                                    style={{color: input.startDate ? '#000000' : '#667085'}}
                                    value={input.startDate}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                            { input.investmentResult &&
                                <FlexRow 
                                    gap="2" padding="1.5" minHeight="7.7" 
                                    radius="0.8" bgColor="#E7F6F5" borderColor="#E7F6F5"
                                    justifyContent="space-between" bottomMargin="2"
                                >
                                    <GridContainer width="auto" sizeUnit="" alignItems="start">
                                        <AppSpan color="#3A3A3A">Expected Return</AppSpan>
                                        <AppText fontWeight="700" color="#0D968F">N100,00.00</AppText>
                                    </GridContainer>
                                    <GridContainer width="auto" sizeUnit="" alignItems="end">
                                        <AppSpan color="#3A3A3A">Maturity Date</AppSpan>
                                        <AppText fontWeight="700" color="#0D968F">12/08/2025</AppText>
                                    </GridContainer>
                                </FlexRow>
                            }
                            <FormGroupWithIcon>
                                <label>Source Account</label>
                                <div className="input-with-icon">
                                    <select 
                                        placeholder="Source Account"
                                        name='sourceAccount'
                                        value={input.sourceAccount}
                                        style={{color: input.sourceAccount ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        //required
                                    >
                                        <option value="">Select Source Account</option>
                                        <option value="2236728192">Qore - 2236728192</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FlexRow topMargin='2.5'>
                                <Button 
                                    width='100' sizeUnit="%" height='4.4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Submit
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </AppCenterPopupD2>
            }
            { view === 'pin' &&
                <TxPinVerificationD2
                    close={close}
                    next={handleSubmit} 
                />
            }
            { view === 'investment-confirmation' &&
                <InvestmentConfirmationD2
                    close={close}
                    next={() => setView('pin')} 
                    back={() => setView('new-investment')}
                    type='savings'
                />
            }
        </>
    )
}